export enum ConfigFields {
    CUSTOMER = 'customer',
    MAIL = 'mail',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
